export const WISHLIST_LOGIN_HEADING = "Sign in to see your Wishlist";

export const BOOKINGS_ROUTE = "my-bookings";

export const MY_CARS_ROUTES = ["myBookings", "my-bookings", "my-wishlist"];
